import HelpOutlineIcon from "@mui/icons-material/HelpOutlineOutlined";
import { Box, Typography } from "@mui/material";
import useColors from "../../../../../../api/hooks/useColors";
import CustomToolTip from "../../../../../../components/CustomTooltip";
import { AWSKmsKeyFieldsDescription } from "../../../../../../utils/constants";
import TextIntegrationStyle from "../../TextIntegrationStyle";
import AWSEntityCommonDetails from "./AWSEntityCommonDetails";

const AWSKmsKeyDetailsView = ({ entityData }) => {
  const colors = useColors();

  return (
    <Box display={"flex"} flexDirection={"column"} gap={2}>
      <AWSEntityCommonDetails entityData={entityData} />

      {entityData?.aws_kms_data?.aliases &&
        entityData?.aws_kms_data?.aliases.length > 0 && (
          <Box display={"flex"} flexDirection={"column"} gap={1}>
            <Box
              display={"flex"}
              flexDirection={"row"}
              alignItems={"center"}
              gap={1}
            >
              <Typography variant={"subtitle2"}>Aliases</Typography>
            </Box>
            <Box ml={2} display={"flex"} flexDirection={"column"} gap={1}>
              {entityData.aws_kms_data?.aliases.map((alias, index) => (
                <TextIntegrationStyle key={index} title={""} value={alias} />
              ))}
            </Box>
          </Box>
        )}

      {entityData?.aws_kms_data?.key_manager && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Managed By</Typography>
          </Box>
          <Box ml={2} display={"flex"} alignItems={"center"} gap={0.5}>
            <TextIntegrationStyle
              title={""}
              value={entityData.aws_kms_data?.key_manager}
            />
            <CustomToolTip
              title={
                AWSKmsKeyFieldsDescription[
                  entityData.aws_kms_data?.key_manager
                ] ?? entityData.aws_kms_data?.key_manager
              }
              placement="right"
            >
              <HelpOutlineIcon
                sx={{
                  color: colors.text_secondary,
                  width: "12px",
                  height: "12px",
                }}
              />
            </CustomToolTip>
          </Box>
        </Box>
      )}

      {entityData?.key_usage && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Usage</Typography>
          </Box>
          <Box ml={2} display={"flex"} alignItems={"center"} gap={0.5}>
            <TextIntegrationStyle title={""} value={entityData.key_usage} />
            <CustomToolTip
              title={
                AWSKmsKeyFieldsDescription[entityData.key_usage] ??
                entityData.key_usage
              }
              placement="right"
            >
              <HelpOutlineIcon
                sx={{
                  color: colors.text_secondary,
                  width: "12px",
                  height: "12px",
                }}
              />
            </CustomToolTip>
          </Box>
        </Box>
      )}

      {entityData?.aws_kms_data?.key_origin && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Key Origin</Typography>
          </Box>
          <Box ml={2} display={"flex"} alignItems={"center"} gap={0.5}>
            <TextIntegrationStyle
              title={""}
              value={entityData.aws_kms_data?.key_origin}
            />
            <CustomToolTip
              title={
                AWSKmsKeyFieldsDescription[
                  entityData.aws_kms_data?.key_origin
                ] ?? entityData.aws_kms_data?.key_origin
              }
              placement="right"
            >
              <HelpOutlineIcon
                sx={{
                  color: colors.text_secondary,
                  width: "12px",
                  height: "12px",
                }}
              />
            </CustomToolTip>
          </Box>
        </Box>
      )}

      {entityData.aws_kms_data?.key_rotation_enabled !== undefined && (
        <Box display={"flex"} flexDirection={"column"} gap={1}>
          <Box
            display={"flex"}
            flexDirection={"row"}
            alignItems={"center"}
            gap={1}
          >
            <Typography variant={"subtitle2"}>Rotation Status</Typography>
          </Box>
          <Box ml={2} display={"flex"} flexDirection={"column"} gap={0.5}>
            <Box display={"flex"} alignItems={"center"} gap={0.5}>
              <TextIntegrationStyle
                title={""}
                value={
                  entityData.aws_kms_data?.key_rotation_enabled
                    ? "Enabled"
                    : "Disabled"
                }
              />
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default AWSKmsKeyDetailsView;
